import React from 'react';

export const NotFound: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className='notFoundLayout'>
      <p className='notFoundLayout--text'>{text}</p>
    </div>
  );
};
